import { Component } from '@angular/core';

@Component({
  selector: 'app-verify-msme-view',
  templateUrl: './verify-msme-view.component.html',
  styleUrl: './verify-msme-view.component.css'
})
export class VerifyMSMEViewComponent {

}
